import { createAction } from '@reduxjs/toolkit';
export const clearSensorGroups = createAction('sensorGroup/sensorGroup/clear');
export const getSensorGroups = createAction('sensorGroup/sensorGroup/get/all');
export const getSensorGroupsResolved = createAction('sensorGroup/sensorGroup/get/all/resolved');
export const getSensorGroupsRejected = createAction('sensorGroup/sensorGroup/get/all/rejected');
